export default "__VITE_ASSET__BT$z1DdZ__"